import { PlaceholderTranslationDto } from "../../dto/placeholders/placeholder-translations.dto";
import { PlaceholderTranslation } from "../../models/placeholders/placeholder.model";

export class PlaceholderTranslationMapper {
  public static toModel(dto: PlaceholderTranslationDto): PlaceholderTranslation {
    return {
      languageId: dto.language_id,
      description: dto.description,
      userQuestion: dto.user_question,
      constraint: dto.constraint
    }
  }

  public static toDto(model: PlaceholderTranslation): PlaceholderTranslationDto {
    return {
      language_id: model.languageId,
      description: model.description,
      user_question: model.userQuestion,
      constraint: model.constraint
    }
  }
}